import { render } from "./SalesmanManagement.vue?vue&type=template&id=5dd57715&scoped=true"
import script from "./SalesmanManagement.vue?vue&type=script&lang=js"
export * from "./SalesmanManagement.vue?vue&type=script&lang=js"

import "./SalesmanManagement.vue?vue&type=style&index=0&id=5dd57715&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd57715"]])

export default __exports__